var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11.625C3 8.51839 5.51839 6 8.625 6H27.375C30.4816 6 33 8.51839 33 11.625V24.375C33 27.4816 30.4816 30 27.375 30H8.625C5.51839 30 3 27.4816 3 24.375V11.625ZM20.625 13.5C19.1752 13.5 18 14.6753 18 16.125V19.875C18 21.3247 19.1752 22.5 20.625 22.5H24.375C25.8248 22.5 27 21.3247 27 19.875V16.125C27 14.6753 25.8248 13.5 24.375 13.5H20.625ZM10.125 13.875C9.50368 13.875 9 14.3787 9 15C9 15.6213 9.50368 16.125 10.125 16.125H13.875C14.4963 16.125 15 15.6213 15 15C15 14.3787 14.4963 13.875 13.875 13.875H10.125ZM10.125 19.875C9.50368 19.875 9 20.3787 9 21C9 21.6213 9.50368 22.125 10.125 22.125H13.875C14.4963 22.125 15 21.6213 15 21C15 20.3787 14.4963 19.875 13.875 19.875H10.125Z",
    fill: "#171717",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessAccount);
export default __webpack_public_path__ + "static/media/access-account.d8289946079c579937a674ee0784f750.svg";
export { ForwardRef as ReactComponent };